import * as Starknet from 'starknet';

import { type StarknetProvider } from '#/features/starknet-wallet/provider';

import { sleep } from '#/utils/sleep';

// WIP Copied and adapted from starknet@4.17. Only compatible with
// sequencer provider. This is needed until we start using transactions
// v1. Transactions v0 is what we currently support and is only
// supported by starknet until version ~4.6.
export async function waitForTransaction(
  provider: StarknetProvider,
  txnHash: Starknet.number.BigNumberish,
  options: {
    retryInterval?: number;
    successStates?: Starknet.Status[];
    errorStates?: Starknet.Status[];
  } = {},
) {
  const retryInterval: number = options.retryInterval ?? 8000;
  const successStates: Starknet.Status[] = options.successStates ?? [
    'ACCEPTED_ON_L1',
    'ACCEPTED_ON_L2',
    'PENDING',
  ];
  const errorStates: Starknet.Status[] = options.errorStates ?? [
    'REJECTED',
    'NOT_RECEIVED',
  ];

  let isOnChain = false;
  let txStatusResp;

  while (!isOnChain) {
    // eslint-disable-next-line no-await-in-loop
    await sleep(retryInterval);

    try {
      // eslint-disable-next-line no-await-in-loop
      txStatusResp = await provider.getTransactionStatus(txnHash);
    } catch (error) {
      // Keep going on connection error
      continue;
    }

    if (successStates.includes(txStatusResp.tx_status)) {
      isOnChain = true;
    } else if (errorStates.includes(txStatusResp.tx_status)) {
      const message =
        `StarkNet transaction ${txStatusResp.tx_status} ` +
        `with reason ${txStatusResp.tx_failure_reason?.code ?? 'unknown'}`;
      throw new Error(message);
    }
  }
  const txReceipt = await provider.getTransactionReceipt(txnHash);
  return txReceipt;
}
